/* @ngInject */

export default () => {
  return {
    restrict: 'E',
    scope: {
      data: '='
    },
    link: function (scope, element) {
      /*
       * Chart dimensions
       * --------------------------------------------------------------------------------
       */
      const chartWidth = 600;
      const chartHeight = 600;
      const svg = d3
        .select(element[0])
        .append('div')
        .attr('class', 'svg-container')
        .append('svg')
        .attr('width', chartWidth)
        .attr('height', chartHeight);

      /*
       * Chart configuration
       * --------------------------------------------------------------------------------
       */
      const arcs = scope.data.data.map((v, i) =>
        d3
          .arc()
          .innerRadius(i * 45 + 45)
          .outerRadius((i + 1) * 45 - 5 + 45)
      );
      const pieData = scope.data.data.map((v, i) => [
        {
          key: v.key,
          value: v.value,
          percentage: v.percentage,
          dimension: v.percentage * 0.75,
          arc: arcs[i]
        },
        {
          key: v.key,
          value: v.value,
          percentage: v.percentage,
          dimension: (100 - v.percentage) * 0.75,
          arc: arcs[i]
        },
        {
          key: v.key,
          value: v.value,
          percentage: v.percentage,
          dimension: 100 * 0.25,
          arc: arcs[i]
        }
      ]);
      const pie = d3
        .pie()
        .sort(null)
        .value((d) => d.dimension);
      const g = svg
        .selectAll('g')
        .data(pieData)
        .enter()
        .append('g')
        .attr('transform', `translate(${chartWidth / 2}, ${chartHeight / 2}) rotate(180)`);

      g.selectAll('path')
        .data((d) => pie(d))
        .enter()
        .append('path')
        .attr('d', (d) => d.data.arc(d))
        .attr('fill', (d, i) => {
          if (i === 0) {
            switch (d.data.key) {
              case 'Created':
                return '#D1D1D1';
              case 'Submitted':
                return '#38A5DC';
              case 'Approved':
                return '#EC7A08';
              case 'Settled':
                return '#3F9C35';
              default:
            }
          }
          return 'none';
        });

      svg.selectAll('g').each(function (d) {
        const el = d3.select(this);
        el.selectAll('path').each((r, i) => {
          if (i === 1) {
            const centroid = r.data.arc.centroid({
              startAngle: r.startAngle + 0.075,
              endAngle: r.startAngle + 0.001 + 0.075
            });
            g.append('text')
              .text(`${r.data.percentage}%`)
              .style('font-size', '1.25em')
              .attr(
                'transform',
                `translate(${centroid[0]}, ${centroid[1]}) rotate(${
                  (180 / Math.PI) * r.startAngle + 7
                })`
              )
              .attr('alignment-baseline', 'middle');
          }
          if (i === 0) {
            const centroid = r.data.arc.centroid({
              startAngle: r.startAngle + 0.075,
              endAngle: r.startAngle + 0.001 + 0.075
            });
            g.append('text')
              .text(
                `${d[0].key} ${String(d[0].value).formatWithCurrency(
                  scope.data.format ? scope.data.currency : '',
                  0
                )}`
              )
              .style('font-size', '1.25em')
              .attr('transform', `translate(-7, ${centroid[1]}) rotate(${180})`)
              .attr('alignment-baseline', 'middle');
          }
        });
      });

      /*
       * Chart viewport
       * --------------------------------------------------------------------------------
       */
      svg
        .attr('width', '100%')
        .attr('height', '100%')
        .attr('viewBox', `0 0 ${chartWidth} ${chartHeight}`)
        .attr('preserveAspectRatio', 'xMidYMid meet');
    }
  };
};
